// ** React Imports
import { useEffect, useState } from 'react'

import { useLocation, useNavigate } from 'react-router-dom'

// ** Context Imports
import { AbilityContext } from 'src/layouts/components/acl/Can'

// ** Config Import
import { buildAbilityFor } from 'src/configs/acl'
import authConfig from 'src/configs/auth'

// ** Component Import
import NotAuthorized from 'src/pages/401'
import BlankLayout from 'src/@core/layouts/BlankLayout'

// ** Hooks
import { useAuth } from 'src/hooks/useAuth'
import { isGuestQmsRoute } from 'src/utils/guestQms'

const AclGuard = props => {
  // ** Props
  const { aclAbilities, children, guestGuard } = props
  const [ability, setAbility] = useState(undefined)

  // ** Hooks
  const auth = useAuth()
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(
    () => {
      if (isGuestQmsRoute(location.pathname, location.search)) {
        return
      }
      if (
        !(
          guestGuard ||
          location.pathname === '/404' ||
          location.pathname === '/500' ||
          location.pathname === '/login' ||
          location.pathname === '/terms-and-conditions' ||
          location.pathname.startsWith('/terms-and-conditions/') ||
          location.pathname === '/verify-otp' ||
          location.pathname === '/change-email' ||
          location.pathname === '/forgot-password' ||
          location.pathname === '/reset-password' ||
          location.pathname === '/account-type' ||
          location.pathname === '/register' ||
          location.pathname === '/scriptions-plan' ||
          location.pathname === '/business-scriptions-plan' ||
          location.pathname === '/otp-verification'
        )
      ) {
        const currentPath = location.pathname + location.search + location.hash
        if (auth.user === null && !window.localStorage.getItem(authConfig.storageUserDataKeyName)) {
          if (currentPath !== '/') {
            navigate(`/login?redirect=${encodeURIComponent(currentPath)}`)
          } else {
            navigate('/login')
          }
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  // If guestGuard is true and user is not logged in or its an error page, render the page without checking access
  if (
    isGuestQmsRoute(location.pathname, location.search) ||
    guestGuard ||
    location.pathname === '/404' ||
    location.pathname === '/500' ||
    location.pathname === '/login' ||
    location.pathname === '/terms-and-conditions' ||
    location.pathname.startsWith('/terms-and-conditions/') ||
    location.pathname === '/verify-otp' ||
    location.pathname === '/change-email' ||
    location.pathname === '/forgot-password' ||
    location.pathname === '/account-type' ||
    location.pathname === '/reset-password' ||
    location.pathname === '/register' ||
    location.pathname === '/scriptions-plan' ||
    location.pathname === '/business-scriptions-plan' ||
    location.pathname === '/otp-verification'
  ) {
    return <>{children}</>
  }

  // User is logged in, build ability for the user based on his role
  if (auth.user && auth.user && !ability) {
    setAbility(buildAbilityFor(auth.user.role, aclAbilities.subject))
  }

  // Check the access of current user and render pages
  if (ability && ability.can(aclAbilities.action, aclAbilities.subject)) {
    return <AbilityContext.Provider value={ability}>{children}</AbilityContext.Provider>
  }

  // Render Not Authorized component if the current user has limited access
  return <BlankLayout>{/* <NotAuthorized /> */}</BlankLayout>
}

export default AclGuard
